import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ["trigger", "channel", "submit", "status"]

  connect() {
    this.checkValidity()
  }

  async checkValidity() {
    const trigger = this.triggerTarget.value
    const channel = this.channelTarget.value

    try {
      const response = await fetch(`/communication_rules/check_validity?trigger=${trigger}&channel=${channel}`)
      const data = await response.json()
      if(data) {
        this.submitTarget.disabled = true
        this.statusTarget.textContent = "Já existe uma regra cadastrada para este gatilho e canal."
        this.statusTarget.classList.remove("d-none")
      } else {
        this.submitTarget.disabled = false
        this.statusTarget.textContent = ''
        this.statusTarget.classList.add("d-none")
      }
    } catch (e) {
      throw new e
    }
  }
}
